import styled from "styled-components";

export const LabelContainer = styled.div`
	margin: 0px;
	padding: 0px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
	width: 100%;
`;

export const Form = styled.form`
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
`;

export const TableWrapper = styled.div`
	max-height: 500px;
	overflow-y: auto;
`;

export const Table = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

export const TableHead = styled.thead``;

export const TableHeaderRow = styled.tr`
	border-bottom: 1px solid #ccc;
`;

export const TableHeader = styled.th`
	padding: 8px;
	text-align: left;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
	cursor: pointer;

	&:hover {
		background-color: #f5f5f5;
	}
`;

export const TableCell = styled.td`
	padding: 8px;
	border-bottom: 1px solid #eee;
`;
